import { MODULES } from '@src/quince-site-common/src/constants/template-info'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { captureRumError, isRumActive, setRumViewContext, trackRumAction } from './rum.helper'

export interface CartRumContext {
  success?: boolean
  source?: string
  quantity?: number
  price?: number
  product_count?: number
  item_count?: number
  is_modal?: boolean
  is_bundle?: boolean
  error_reason?: string
  [key: string]: unknown
}

export const getCartUiVariant = (): 'ds' | 'legacy' => (shouldUseDesignSystem() ? 'ds' : 'legacy')

export const trackCartAction = (action: string, context: CartRumContext = {}): void => {
  if (!isRumActive()) return
  trackRumAction(action, { cart_ui_variant: getCartUiVariant(), ...context })
}

export const captureCartError = (error: unknown, feature: string, context: Record<string, unknown> = {}): void => {
  if (!isRumActive()) return
  captureRumError(error, { module: MODULES.CART, feature, cart_ui_variant: getCartUiVariant(), ...context })
}

export const CART_RUM_PAGE_TYPE = 'cart'

export const setCartPageRumType = (): void => {
  setRumViewContext('page_type', CART_RUM_PAGE_TYPE)
}
